import { useEffect } from "react";
import { createPlugin } from "@backstage/core-plugin-api"; // Added import
import {
  createTechDocsAddonExtension,
  TechDocsAddonLocations,
  useTechDocsReaderPage,
  useShadowRoot,
} from "@backstage/plugin-techdocs-react";
import { getDocType } from "./constants";

export const DocTypeBackgroundComponent = () => {
  const shadowRoot = useShadowRoot();
  const { entityMetadata } = useTechDocsReaderPage();

  useEffect(() => {
    if (!shadowRoot || !entityMetadata.value) return;

    const docType = getDocType(
      entityMetadata.value.metadata.annotations?.[
        "backstage.io/managed-by-location"
      ],
    );
    const host = shadowRoot.host as HTMLElement;

    if (docType === "official") {
      host.style.setProperty("--md-default-bg-color", "#f0f7ff", "important");
    } else if (docType === "engineering") {
      host.style.setProperty("--md-default-bg-color", "#fffdf5", "important");
    } else {
      host.style.removeProperty("--md-default-bg-color");
    }
  }, [shadowRoot, entityMetadata]);

  return null;
};

// 1. Create a plugin instance
const docTypeBackgroundPlugin = createPlugin({
  id: "doc-type-background",
});

// 2. Use .provide() to export the extension as a renderable component
export const DocTypeBackground = docTypeBackgroundPlugin.provide(
  createTechDocsAddonExtension({
    name: "DocTypeBackground",
    location: TechDocsAddonLocations.Content,
    component: DocTypeBackgroundComponent,
  }),
);
